<template>
  <div class="animated">
    <SubmissionServerTable
      v-if="submission_collection"
      :collection="submission_collection"
    />
  </div>
</template>

<script>
import SubmissionCollection from '@/collections/lab/SubmissionCollection'
import SubmissionServerTable from '../../submissions/SubmissionServerTable.vue'

export default {
  name: 'ProjectSubmissionTable',
  components: {
    SubmissionServerTable
  },
  props: {
    project: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      submission_collection: null
    }
  },
  async created () {
    const collection = new SubmissionCollection()
    const filter = collection.getFilter()
    filter.filterEquals('project_id', this.project.id)

    filter.cacheStaticFilters()
    this.submission_collection = collection
  }
}
</script>
